import { useMemo } from "react";
import { useSelector } from "react-redux";

import permissions from "@utils/permissions";
import useRoleIs from "@utils/useRoleIs";

import { useOrderWindowsListQuery } from "./data";

const useOrderableOrderWindowsQuery = () => {
  const roleIs = useRoleIs();
  const channelId = useSelector(
    (state: any) => state.currentUser.currentChannelId
  );
  const territoryId = useSelector(
    (state: any) => state.currentUser.currentTerritoryId
  );

  const { data = [], isPending } = useOrderWindowsListQuery(
    { filter: { isActive: true }, sort: "in-market-date" },
    { enabled: roleIs(permissions.internalRoles) }
  );

  const filteredData = useMemo(
    () =>
      data
        .filter((w) => !channelId || w.channel?.id === channelId)
        .map((ow) => ({
          ...ow,
          programs: ow.programs.filter(
            (program) =>
              program.isActive &&
              program.status === "complete" &&
              program.territories.some((t) => t.id === territoryId)
          ),
        }))
        .filter((ow) => ow.programs.length > 0),
    [channelId, territoryId, data]
  );

  return {
    data: filteredData,
    isPending,
  };
};

export default useOrderableOrderWindowsQuery;
